export default __webpack_public_path__ + "static/media/spinner.8e58be17.gif";